import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import useAsyncRequest from "hooks/useAsyncRequest";
import { LoadablePage } from "shared/LoadablePage";
import CopyToClipboardWrapper from "components/CopyToClipboardWrapper";
import { EntityProvider } from "components/EntityProvider/EntityProvider";
import NavigationSidebarLayout, { Navigation } from "components/NavigationSidebarLayout/NavigationSidebarLayout";
import { PaperLayout } from "components/PaperLayout/PaperLayout";
import { RbacPolicies } from "components/authorization/RbacPolicies";
import { rateCardRoutes } from "../rate-card-routes";
import { getRateCardByCode } from "../services/rateCardService";

function getValueOrFallbackFor(rateCardCode?: string) {
  return rateCardCode || "UNKNOWN_RATE_CARD";
}

export function RateCardDetailLayout() {
  const { rateCardCode } = useParams<{ rateCardCode: string }>();

  const {
    data: rateCard,
    loading,
    error,
    refresh,
  } = useAsyncRequest(getRateCardByCode, getValueOrFallbackFor(rateCardCode));

  const navLinks = [
    Navigation.navItem("Details", rateCardRoutes.detail(rateCardCode ?? "").root, true, RbacPolicies.RateCards.Read),
  ];

  const preNavbarComponent = (
    <CopyToClipboardWrapper value={rateCardCode}>
      <Tooltip title="Rate card code">
        <span>{rateCardCode}</span>
      </Tooltip>
    </CopyToClipboardWrapper>
  );

  return (
    <LoadablePage loading={loading && !rateCard} error={error}>
      <EntityProvider entity={rateCard} refresh={refresh}>
        <NavigationSidebarLayout navLinks={navLinks} name={"Rate card"} preNavbarComponent={preNavbarComponent}>
          <PaperLayout maxWidth={false}>
            <Outlet />
          </PaperLayout>
        </NavigationSidebarLayout>
      </EntityProvider>
    </LoadablePage>
  );
}
